import { AutoCountTextControlFactory } from "appworks/ui/factories/autoplay/auto-count-text-control-factory";
import { AutoLossLimitRadioControlFactory } from "appworks/ui/factories/autoplay/auto-loss-limit-radio-control-factory";
import { AutoSingleWinRadioControlFactory } from "appworks/ui/factories/autoplay/auto-single-win-radio-control-factory";
import { AutoSpinsCountRadioControlFactory } from "appworks/ui/factories/autoplay/auto-spins-count-radio-control-factory";
import { AutoStartControlFactory } from "appworks/ui/factories/autoplay/auto-start-control-factory";
import { AutoStopControlFactory } from "appworks/ui/factories/autoplay/auto-stop-control-factory";
import { StopOnFeatureControlFactory } from "appworks/ui/factories/autoplay/stop-on-feature-control-factory";
import { EpicAutoplayControlFactory } from "epic/controls/factories/epic-autoplay-control-factory";
import { EpicAutoplayMenuControlFactory } from "epic/controls/factories/epic-autoplay-menu-control-factory";

export function GetEpicAutoplayFactories() {
    return [
        new AutoSpinsCountRadioControlFactory(),
        new AutoLossLimitRadioControlFactory(false),
        new AutoSingleWinRadioControlFactory(false),
        new AutoStartControlFactory(),
        new AutoStopControlFactory(),
        new AutoCountTextControlFactory(),
        new StopOnFeatureControlFactory(),
        new EpicAutoplayControlFactory(),
        new EpicAutoplayMenuControlFactory()
    ];
}
